import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '../context/AuthContext';
import { useDarkMode } from '../context/DarkModeContext';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const { darkMode } = useDarkMode();
  const location = useLocation();

  if (isLoading) {
    return (
      <div
        className={`min-h-screen flex items-center justify-center ${
          darkMode ? 'bg-slate-900' : 'bg-slate-50'
        }`}
      >
        <Loader2
          className={`w-8 h-8 animate-spin ${
            darkMode ? 'text-slate-400' : 'text-slate-500'
          }`}
        />
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (user && !user.isVerified) {
    return <Navigate to="/verify-prompt" replace />;
  }

  return <Outlet />;
}
